import { useContext } from 'react';
import { HalfMagicContext } from '../components/half-magic-link-handler/half-magic-link-context';

export const useIsHalfMagicLoggedIn = () => {
  const { halfMagicLoggedIn, loading } = useContext(HalfMagicContext);

  return { halfMagicLoggedIn, loading };
};
